import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NestedCheckbox from "components/common/nestedCheckbox/NestedCheckbox";
import { useTranslation } from "react-i18next";
const ClaimsInfo = (props) => {
  const {
    permissions,
    handleChangeClaims,
    loading,
    formik,
    back,
    handleError,
    handleCompletion,
    location,
  } = props;
  const { t } = useTranslation();
  const STEP_ID = 3;
  useEffect(() => {
    handleError(STEP_ID, false);
    handleCompletion(STEP_ID, true);
  }, []);
  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <div>
        {permissions.length > 0 ? (
          <>
          <h6>{t("products")}</h6>
            <p>{t("users-access")}</p>
            <div className="claims">
              <NestedCheckbox
                formik={formik}
                permissionsList={permissions}
                component={"claims info"}
                handleChange={handleChangeClaims}
              />
            </div>
          </>
        ) : (
          <>
            {location?.hash === "#AU" ? <p>
              {t("no-permission")}
            </p> : <p>
              You are not authorized to assign any product permission. Please
              contact branch admin.
            </p>}
          </>

        )}
      </div>
      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            marginRight: "15px",
            backgroundColor: "gray",
          }}
          onClick={back}
        >
          {t("back")}
        </button>
        {permissions.length > 0 && (
          <button
            className="parentbtn"
            style={{
              padding: "10px 35px",
            }}
            type="submit"
          >
            {loading ? <Spinner animation="border" size="sm" /> : t("add-user")}
          </button>
        )}
        {location?.hash === "#AU" && <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
          }}
          type="submit"
        >
          {loading ? <Spinner animation="border" size="sm" /> : t("add-user")}
        </button>}
      </div>
    </div>
  );
};

export default ClaimsInfo;
